<template>
  <div class="selsee">
    <a-popover placement="topLeft">
      <template slot="content">
        <div v-for="i in letter" class="p" style="padding:4px 0;">{{i.title}}</div>
      </template>
      <div class="span">
        <span v-for="i in letter">{{i.title}}</span>
      </div>
    </a-popover>
  </div>
</template>
<script>
export default {
  props: {
    ids: Array, //列表id,
    list: Array
  },
  computed: {
    letter() {
      if (this.ids && this.list) {
        return this.list.filter(ele => {
          return this.ids.indexOf(ele.id) >= 0
        })
      }
    }
  },
  data() {
    return {

    }
  }
}
</script>
<style lang="less" scoped>
.selsee {
  border: 1px solid #000;
  line-height: 32px;
  margin-top: 3px;
  border-radius: 4px;
  padding: 0 5px;
  .span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  span {
    margin-right: 6px;
  }
}
</style>